import {NgClass} from '@angular/common';
import {ChangeDetectorRef, Component, EventEmitter, Output} from '@angular/core';
import {NbButtonGroupModule, NbButtonModule, NbIconModule, NbTooltipModule} from '@nebular/theme';

export type Tabs = 'list' | 'table'

@Component({
  standalone: true,
  selector: 'app-view-changing-tabs',
  templateUrl: './view-changing-tabs.component.html',
  styleUrls: ['./view-changing-tabs.component.scss'],
  imports: [
    NgClass,
    NbIconModule,
    NbTooltipModule,
    NbButtonGroupModule,
    NbButtonModule
  ]
})
export class ViewChangingTabsComponent {
  constructor(
    private cdr: ChangeDetectorRef
  ) {
  }

  view: Tabs = localStorage.getItem('damView') as Tabs || 'table';

  @Output() public viewChangeEvent = new EventEmitter<Tabs>();

  showProductBlocks(view: Tabs) {
    console.log('view', this.view)
    this.cdr.markForCheck();
    this.saveViewOnLocalStorage(view)
    this.view = view
    this.viewChangeEvent.emit(view)
  }

  saveViewOnLocalStorage(view: Tabs) {
    localStorage.setItem('damView', view);
  }
}
